// React
import React from 'react';
// Api Services
import ApiServices from 'services/ApiServices';
// componentes
import Title from 'components/TitleWithIcon';
import Modal from 'components/CustomDialog';
import { Grid, List, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText } from '@material-ui/core';
import {useStyles} from './style';
import { Send, Remove, Computer, Event } from '@material-ui/icons';

const  CambiosRealizadosEnElSistema= (props)=> {
        const classes = useStyles();
        const listaDeCambios = [
            {iconOne: <Computer/>, titleVersion: 'Versión 2.2.4', titleDate: '23/08/2022', iconTwo: <Event/>, text:''},
                {
                    title: 'Botón Descargar Constancia de Empadronamiento', 
                    text:'Se creó una ventana emergente con el botón “Descargar Constancia”. Esta ventana se muestra cuando se procesa una solicitud de origen Delegación/subdelegación.'
                },
            {iconOne: <Computer/>, titleVersion: 'Versión 2.2.3', titleDate: '20/07/2022', iconTwo: <Event/>, text:''},
                {
                    title: 'Botón Reportar Caso a Informática', 
                    text:'Se removió el botón “Reportar Caso a Informática” que se encuentra en el proceso de las solicitudes provenientes de RENAP al momento de verificar e ingresar los datos de residencia electoral del ciudadano. (De acuerdo al oficio: DICEP-PWGE-0-066-2022)'
                },
                {
                    title: 'Botón Enviar a caso especial', 
                    text:'Se removió el botón “Enviar a caso especial” que se encuentra en el proceso de las solicitudes provenientes de Delegación/Subdelegación donde es visible cuando se selecciona el checkbox que se encuentra de lado izquierdo en el listado de homonimia. (De acuerdo al oficio: DICEP-PWGE-0-066-2022)'
                },
            {iconOne: <Computer/>, titleVersion: 'Versión 2.2.2', titleDate: '01/07/2022', iconTwo: <Event/>, text:''},
                {title: 'Procesamiento de solicitudes:', text:'Las solicitudes solo pueden ser procesadas únicamente por el usuario que la generó.'},
                {title: 'Parámetros en las solicitudes:', 
                    text:'Todos los parámetros o campos están validados para recibir el máximo de caracteres permitidos. Ejemplo #1, el campo “zona” recibirá únicamente 2 caracteres, ejemplo: zona = “12”. '+
                    'Ejemplo #2, el campo "No. Casa/Lote" recibirá únicamente 10 caracteres, ejemplo: No. Casa/Lote: "Lote 25-96"'
                },
                {title: 'Código GeoElectoral:', text:'Se modificó la funcionalidad del Código GeoElectoral de la comunidad, solucionando el inconveniente.'},
                {title: 'Documento de la solicitud:', text:'Se quitó la opción “Descargar solicitud” del módulo de “Solicitudes Aprobadas”.'},
        ]
        return (
            <Modal 
                open={props.open}
                fullScreen={true}
                closeModal={props.closeModal}
                actualizarTabla={props.actualizarTabla}
                iconToolbar={props.iconToolbar}
                titleToolbar={'Cambios realizados en el sistema'}
            >
                <Grid container style={{textAlign: 'center'}}>
                    <div className={classes.colorComponente}>
                        <Grid item xs={12} direction="row" justify="center" alignItems="center">
                            <List className={classes.listRoot}>
                                    {
                                        listaDeCambios.map((text, index) => {
                                            return (
                                                <>
                                                        {
                                                            (text.text === '') ? 
                                                                <ListItem className={classes.listItemTitlePrincipal}>
                                                                    <ListItemIcon className={classes.ListItemIcon}>
                                                                        {text.iconOne}
                                                                    </ListItemIcon>
                                                                    <ListItemText>
                                                                        <span >
                                                                             {text.titleVersion}
                                                                        </span>
                                                                    </ ListItemText>
                                                                    <ListItemIcon className={classes.ListItemIcon}>
                                                                        {text.iconTwo}
                                                                    </ListItemIcon>
                                                                    <ListItemText>
                                                                        <span >
                                                                            {text.titleDate}
                                                                        </span>
                                                                    </ ListItemText><br/>
                                                                </ListItem>
                                                            :
                                                                <>
                                                                    <ListItem className={classes.listItemTitle}>
                                                                        <ListItemIcon>
                                                                            <Send color="primary"/>
                                                                        </ListItemIcon>
                                                                        <ListItemText>
                                                                            <span style={{color: 'black', fontWeight: 'bold'}}>
                                                                                {text.title}
                                                                            </span>
                                                                        </ ListItemText><br/>
                                                                    </ListItem>
                                                                    <ListItem className={classes.listItemDescription}>
                                                                        <ListItemText style={{color: '#3B3B3B'}}>
                                                                            {text.text}
                                                                        </ListItemText>
                                                                    </ListItem>
                                                                </>
                                                        }
                                                </>
                                            )
                                        })                                
                                    }
                                </List>  
                        </Grid>
                        <div className={classes.lineaDegradadaBottom}></div>
                    </div>
                </Grid>
            </Modal>
        )
}

export default CambiosRealizadosEnElSistema;